import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearAllStudentData } from '../../utils/clearStudentData';

interface User {
  id?: string;
}

interface User {
  userName?: string;
  phone?: string;
  fullName?: string;
  id?: string;
  role?: string;
}

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: User | null;
}

// Try to get user data from localStorage
const getUserFromStorage = (): User | null => {
  try {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsedUser = JSON.parse(userData);
      return {
        id: parsedUser.id
      };
    }
  } catch (error) {
  }
  return null;
};

const token = localStorage.getItem('token');
const initialState: AuthState = {
  isAuthenticated: !!token,
  token: token,
  user: getUserFromStorage(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      // localStorage.setItem('token', action.payload); // REMOVE - handled by redux-persist
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      // localStorage.setItem('userData', JSON.stringify({ // REMOVE - handled by redux-persist
      //   id: action.payload.id
      // })); // REMOVE
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      // Clear all student data comprehensively for privacy
      clearAllStudentData().catch(error => {
        // Fallback to basic clearing if comprehensive clearing fails
        localStorage.clear();
        sessionStorage.clear();
      });
    },
  },
});

export const { setAuthenticated, setToken, setUser, logout } = authSlice.actions;
export default authSlice.reducer;